import * as React from "react";
import type { SVGProps } from "react";
const SvgIconSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.48.55q-1.22.09-2.32.61c-1.3.62-2.38 1.7-3 3-1 2.12-.8 4.6.56 6.5.9 1.26 2.22 2.15 3.72 2.51.75.18 1.61.22 2.4.12 1.1-.16 2.2-.63 3.09-1.34l.12-.1 1.77 1.77c1.93 1.93 1.81 1.82 2.02 1.85.36.03.67-.28.63-.64-.03-.2.07-.1-1.85-2.01l-1.76-1.77.07-.09c.28-.35.6-.84.8-1.26.44-.94.63-1.87.6-2.92q-.03-1.55-.74-2.86c-.92-1.7-2.52-2.9-4.41-3.27C7.64.55 7 .51 6.48.55m.02 1.14-.26.03c-1.35.18-2.57.88-3.43 1.96q-.88 1.1-1.1 2.56c-.03.24-.04.9-.02 1.17.16 1.76 1.19 3.31 2.74 4.16 1.72.93 3.84.83 5.47-.28 1.06-.72 1.83-1.83 2.15-3.08.1-.43.15-.8.15-1.27 0-.5-.05-.86-.16-1.3q-.33-1.28-1.23-2.26C9.95 2.44 8.77 1.84 7.5 1.7c-.2-.02-.79-.02-1 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconSearch;
